import React from 'react';
import { Box, Typography } from '@mui/material';
import ChipInput from './ChipInput';
import FormFieldLabel from './FormFieldLabel';
import {
  EVENT_TOPIC_SUGGESTIONS,
  addTopicToList,
  removeTopicFromList,
} from '../eventTopicsConstants';

const EventTopicsField = ({ value = [], onChange, error = false, helperText = '' }) => (
  <Box>
    <FormFieldLabel>Events Topic</FormFieldLabel>
    <Typography
      sx={{
        fontSize: '0.8125rem',
        color: 'text.secondary',
        lineHeight: 1.45,
        mb: 1.25,
      }}
    >
      Topics help members discover relevant events and improve attendee recommendations.
    </Typography>

    <ChipInput
      value={value}
      onChange={onChange}
      placeholder="Search"
      suggestions={EVENT_TOPIC_SUGGESTIONS}
      error={error}
      helperText={helperText}
      onAddItem={addTopicToList}
      onRemoveItem={removeTopicFromList}
    />
  </Box>
);

export default EventTopicsField;
